import { Select, type SelectOption } from './Select';
import { useCurrencies } from '@/hooks/useCurrencies';

export interface CurrencySelectProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  id?: string;
}

/**
 * Dropdown loaded from the clients webapp reference database through CBS.
 * Value is the 3-letter code (e.g. "EUR"), label shows the
 * long name and code.
 */
export function CurrencySelect({
  value,
  onChange,
  placeholder = 'Select currency…',
  error,
  disabled,
  id,
}: CurrencySelectProps) {
  const { currencies, loading, error: loadError, unavailable } = useCurrencies();
  const currencySelectOptions: SelectOption[] = currencies.map((currency) => ({
    value: currency.code,
    label: `${currency.code} — ${currency.name}`,
  }));
  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      options={currencySelectOptions}
      placeholder={
        loading ? 'Loading currencies…' : unavailable ? 'Currencies unavailable' : placeholder
      }
      error={error ?? (loadError ? 'Unable to load currencies' : undefined)}
      disabled={disabled || unavailable}
    />
  );
}
